module.exports = __webpack_public_path__ + "img/dan-survey-pad-lake.971bb511.jpg";